// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maincontent-Dis {
  display: flex;
  padding-bottom: 1.5rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  align-self: stretch;
}

.distex {
  font-family: Inter;
}

/* .toppart {
  display: flex;
  padding: 1.5rem;
  padding-left: clamp(1rem, 5vw, 2.5rem);
  align-items: flex-start;
  align-self: stretch;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 0.3125rem;
}

.breadcrumb-element1 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
} */

.div-maindis {
  display: flex;
  padding: 0 1rem;
  flex-direction: column;
  align-items: center;
  flex: 1 0;
  align-self: stretch;
}

.ass-dis {
  display: flex;
  padding: 2rem 1rem 120px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  flex: 1 0;
  align-self: stretch;
}

.frame-110 {
  display: flex;
  width: clamp(300px, 80vw, 640px);
  padding: clamp(1rem, 3vw, 2rem); 
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: clamp(1.5rem, 4vw, 3rem);
  border-radius: 16px;
  border: 1px solid var(--Neutral-300, #CBD5E1);
  background: #FFF;
}

.frame-111 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: clamp(1.5rem, 4vw, 3rem); 
  align-self: stretch;
}

.frame-112 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: clamp(1rem, 3vw, 2rem);
  align-self: stretch;
}

.frame-113 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.para {
  align-self: stretch;
  color: var(--Neutral-700, #334155);
  font-family: Inter;
  font-size: clamp(1rem, 3vw, 1.125rem); 
  font-style: normal;
  font-weight: 400;
  line-height: clamp(1.5rem, 5vw, 2.25rem); 
}

.frame-114 {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  gap: 1rem;
  align-self: stretch;
}

.learn-more-dis {
  display: flex;
  width: 100%;
  height: auto;
  padding: 0.875rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 4px;
  border: 1px solid var(--Neutral-500, #64748B);
  background: var(--Neutral-200, #E2E8F0);
}

.learn-more-dis label {
  color: #000;
  font-family: Inter;
  font-size: clamp(1rem, 3vw, 1.125rem);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}


.learn-more-dis:hover {
  background: 1px solid var(--Neutral-500, #bbc0c7);
}


.agree-dis {
  display: flex;
  width: 100%;
  padding: 0.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  border-radius: 4px;
  border: 0.5px solid #0A5B42;
  background: linear-gradient(180deg, #0C8F63 0%, #0A7253 103.57%);
}

.agree-dis:hover{
  background: linear-gradient(180deg, #096e4c 0%, #07543d 103.57%);
}

.agree-dis label {
  color: #F8FAFC;
  text-align: center;
  font-family: Inter;
  font-size: clamp(1rem, 3vw, 1.125rem);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Label-Large-Line-Height, 20px);
  letter-spacing: var(--Label-Large-Tracking, 0.1px);
}


@media (max-width: 479px) {
  .toppart {
    padding: 1rem;
    padding-left: 1rem;
  }

  .breadcrumb {
    font-size: 0.875rem;
  }

  .div-maindis {
    padding: 0 0.75rem;
  }

  .ass-dis {
    padding-bottom: 40px;
    gap: 1rem;
  }

  .frame-110 {
    padding: 1rem;
    gap: 1rem;
  }

  .frame-111 {
    gap: 1rem;
  }

  .frame-112 {
    gap: 0.5rem;
  }

  .distex {
    font-size: 1.75rem;
    line-height: 2.25rem;
  }

  .para {
    font-size: 1rem;
    line-height: 1.75rem;
  }

  .frame-114 {
    flex-direction: column;
    gap: 0.75rem;
  }

  .learn-more-dis label,
  .agree-dis label {
    font-size: 1rem;
  }
}

@media (min-width: 480px) and (max-width: 575px) {
  .toppart {
    padding-left: 1.5rem;
  }

  .div-maindis {
    padding: 0 1rem;
  }

  .ass-dis {
    padding-bottom: 60px;
    gap: 1.25rem;
  }

  .frame-110 {
    padding: 1.25rem;
    gap: 1.25rem;
  }

  .frame-114 {
    flex-direction: row; /* Keep buttons side-by-side if space allows */
    justify-content: flex-end;
  }
}

/* --- Medium Devices (Tablets, 576px - 767px) --- */
@media (min-width: 576px) and (max-width: 767px) {
  .toppart {
    padding-left: 2rem;
  }

  .div-maindis {
    padding: 0 1.5rem;
  }

  .ass-dis {
    padding-bottom: 80px;
    gap: 1.5rem;
  }

  .frame-110 {
    padding: 1.5rem;
    gap: 1.5rem;
  }

  .frame-114 {
    flex-direction: row;
    justify-content: flex-end;
  }
}

/* --- Large Devices (Desktops, 768px - 991px) --- */
@media (min-width: 768px) and (max-width: 991px) {
  .frame-110 {
    padding: 2rem;
    gap: 2.5rem;
  }

  .para {
    font-size: 1.05rem;
    line-height: 2rem;
  }

  .learn-more-dis label,
  .agree-dis label {
    font-size: 1.05rem;
  }

  .frame-114 {
    flex-direction: row;
    justify-content: flex-end;
  }
}

/* --- Extra Large Devices (Large Desktops, 992px - 1199px) --- */
@media (min-width: 992px) and (max-width: 1199px) {
  .frame-110 {
    padding: 2.5rem;
    gap: 3rem;
  }

  .para {
    font-size: 1.1rem;
    line-height: 2.1rem;
  }

  .learn-more-dis label,
  .agree-dis label {
    font-size: 1.1rem;
  }

  .frame-114 {
    flex-direction: row;
    justify-content: flex-end;
  }
}

/* --- Extra Extra Large Devices (Very Large Desktops, 1200px and up) --- */
@media (min-width: 1200px) {
  .frame-110 {
    padding: 32px;
    gap: 40px;
  }

  .para {
    font-size: 16px;
    line-height: 32px;
  }

  .learn-more-dis label,
  .agree-dis label {
    font-size: 16px;
  }

  .frame-114 {
    flex-direction: row;
    justify-content: flex-end;
  }
}

@media( max-width: 480px){
  .para {
    font-size: 14px;
    line-height: 1.1rem;
  }

  .learn-more-dis{
    height: 35px;
  }
  .agree-dis{
    height:35px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Disclaimer/Disclaimer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,iDAAiD;AACnD;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,kDAAkD;AACpD;;;AAGA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,mBAAmB,EAAE,8CAA8C;IACnE,yBAAyB;EAC3B;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".maincontent-Dis {\n  display: flex;\n  padding-bottom: 1.5rem;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.distex {\n  font-family: Inter;\n}\n\n/* .toppart {\n  display: flex;\n  padding: 1.5rem;\n  padding-left: clamp(1rem, 5vw, 2.5rem);\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 0.3125rem;\n}\n\n.breadcrumb-element1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n} */\n\n.div-maindis {\n  display: flex;\n  padding: 0 1rem;\n  flex-direction: column;\n  align-items: center;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.ass-dis {\n  display: flex;\n  padding: 2rem 1rem 120px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.frame-110 {\n  display: flex;\n  width: clamp(300px, 80vw, 640px);\n  padding: clamp(1rem, 3vw, 2rem); \n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: clamp(1.5rem, 4vw, 3rem);\n  border-radius: 16px;\n  border: 1px solid var(--Neutral-300, #CBD5E1);\n  background: #FFF;\n}\n\n.frame-111 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: clamp(1.5rem, 4vw, 3rem); \n  align-self: stretch;\n}\n\n.frame-112 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: clamp(1rem, 3vw, 2rem);\n  align-self: stretch;\n}\n\n.frame-113 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.para {\n  align-self: stretch;\n  color: var(--Neutral-700, #334155);\n  font-family: Inter;\n  font-size: clamp(1rem, 3vw, 1.125rem); \n  font-style: normal;\n  font-weight: 400;\n  line-height: clamp(1.5rem, 5vw, 2.25rem); \n}\n\n.frame-114 {\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n  gap: 1rem;\n  align-self: stretch;\n}\n\n.learn-more-dis {\n  display: flex;\n  width: 100%;\n  height: auto;\n  padding: 0.875rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.625rem;\n  border-radius: 4px;\n  border: 1px solid var(--Neutral-500, #64748B);\n  background: var(--Neutral-200, #E2E8F0);\n}\n\n.learn-more-dis label {\n  color: #000;\n  font-family: Inter;\n  font-size: clamp(1rem, 3vw, 1.125rem);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n\n.learn-more-dis:hover {\n  background: 1px solid var(--Neutral-500, #bbc0c7);\n}\n\n\n.agree-dis {\n  display: flex;\n  width: 100%;\n  padding: 0.75rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  align-self: stretch;\n  border-radius: 4px;\n  border: 0.5px solid #0A5B42;\n  background: linear-gradient(180deg, #0C8F63 0%, #0A7253 103.57%);\n}\n\n.agree-dis:hover{\n  background: linear-gradient(180deg, #096e4c 0%, #07543d 103.57%);\n}\n\n.agree-dis label {\n  color: #F8FAFC;\n  text-align: center;\n  font-family: Inter;\n  font-size: clamp(1rem, 3vw, 1.125rem);\n  font-style: normal;\n  font-weight: 500;\n  line-height: var(--Label-Large-Line-Height, 20px);\n  letter-spacing: var(--Label-Large-Tracking, 0.1px);\n}\n\n\n@media (max-width: 479px) {\n  .toppart {\n    padding: 1rem;\n    padding-left: 1rem;\n  }\n\n  .breadcrumb {\n    font-size: 0.875rem;\n  }\n\n  .div-maindis {\n    padding: 0 0.75rem;\n  }\n\n  .ass-dis {\n    padding-bottom: 40px;\n    gap: 1rem;\n  }\n\n  .frame-110 {\n    padding: 1rem;\n    gap: 1rem;\n  }\n\n  .frame-111 {\n    gap: 1rem;\n  }\n\n  .frame-112 {\n    gap: 0.5rem;\n  }\n\n  .distex {\n    font-size: 1.75rem;\n    line-height: 2.25rem;\n  }\n\n  .para {\n    font-size: 1rem;\n    line-height: 1.75rem;\n  }\n\n  .frame-114 {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .learn-more-dis label,\n  .agree-dis label {\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 480px) and (max-width: 575px) {\n  .toppart {\n    padding-left: 1.5rem;\n  }\n\n  .div-maindis {\n    padding: 0 1rem;\n  }\n\n  .ass-dis {\n    padding-bottom: 60px;\n    gap: 1.25rem;\n  }\n\n  .frame-110 {\n    padding: 1.25rem;\n    gap: 1.25rem;\n  }\n\n  .frame-114 {\n    flex-direction: row; /* Keep buttons side-by-side if space allows */\n    justify-content: flex-end;\n  }\n}\n\n/* --- Medium Devices (Tablets, 576px - 767px) --- */\n@media (min-width: 576px) and (max-width: 767px) {\n  .toppart {\n    padding-left: 2rem;\n  }\n\n  .div-maindis {\n    padding: 0 1.5rem;\n  }\n\n  .ass-dis {\n    padding-bottom: 80px;\n    gap: 1.5rem;\n  }\n\n  .frame-110 {\n    padding: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .frame-114 {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n/* --- Large Devices (Desktops, 768px - 991px) --- */\n@media (min-width: 768px) and (max-width: 991px) {\n  .frame-110 {\n    padding: 2rem;\n    gap: 2.5rem;\n  }\n\n  .para {\n    font-size: 1.05rem;\n    line-height: 2rem;\n  }\n\n  .learn-more-dis label,\n  .agree-dis label {\n    font-size: 1.05rem;\n  }\n\n  .frame-114 {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n/* --- Extra Large Devices (Large Desktops, 992px - 1199px) --- */\n@media (min-width: 992px) and (max-width: 1199px) {\n  .frame-110 {\n    padding: 2.5rem;\n    gap: 3rem;\n  }\n\n  .para {\n    font-size: 1.1rem;\n    line-height: 2.1rem;\n  }\n\n  .learn-more-dis label,\n  .agree-dis label {\n    font-size: 1.1rem;\n  }\n\n  .frame-114 {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n/* --- Extra Extra Large Devices (Very Large Desktops, 1200px and up) --- */\n@media (min-width: 1200px) {\n  .frame-110 {\n    padding: 32px;\n    gap: 40px;\n  }\n\n  .para {\n    font-size: 16px;\n    line-height: 32px;\n  }\n\n  .learn-more-dis label,\n  .agree-dis label {\n    font-size: 16px;\n  }\n\n  .frame-114 {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n@media( max-width: 480px){\n  .para {\n    font-size: 14px;\n    line-height: 1.1rem;\n  }\n\n  .learn-more-dis{\n    height: 35px;\n  }\n  .agree-dis{\n    height:35px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
